import { Component, OnInit, ViewChild } from '@angular/core';
import { BigDayBucketGenSvc,
  BigDayBucket,
  WellnessWorkOrder,
  Employee} from 'src/app/services_autogenerated/generated_services';
import { WorkOrderFilterPipe } from 'src/app/pipes/work-order-filter.pipe';
import { FilteredWellnessWorkOrder } from 'src/app/models/filteredWellnessWorkOrder';
import { WorkOrderFilterBarComponent } from '../work-order-filter-bar/work-order-filter-bar.component';
import { FilteredWorkWorkOrder } from 'src/app/models/filteredWorkWorkOrder';
import { FilteredQuoteWorkOrder } from 'src/app/models/filteredQuoteWorkOrder';
import { WorkOrderHelperService } from 'src/app/services/work-order-helper.service';

@Component({
    selector: 'app-multiday-jobs-panel',
    templateUrl: './multiday-jobs-panel.component.html',
    styleUrls: ['./multiday-jobs-panel.component.css'],
    providers: [WorkOrderFilterPipe],
    standalone: false
})
export class MultidayJobsPanelComponent implements OnInit {
  selectedView = 'day';
  allBigDayBuckets: BigDayBucket[] = [];
  filteredBigDayBuckets: BigDayBucket[] = [];
  rms: Employee[];
  equipmentTypes: any[];
  isLoading: boolean;

  allWorkOrders: WellnessWorkOrder[];
  filteredWorkOrders: FilteredWellnessWorkOrder[];
  @ViewChild(WorkOrderFilterBarComponent) filterBarComponent: WorkOrderFilterBarComponent;

  constructor(
    private bigDayBucketService: BigDayBucketGenSvc,
    private workOrderHelper: WorkOrderHelperService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.bigDayBucketService.getWithWellnessWorkOrders().subscribe(bdb => {
      this.allBigDayBuckets = bdb;
      this.filteredBigDayBuckets = bdb;

      this.allWorkOrders = this.allBigDayBuckets.filter(x => x.wellnessWorkOrder).map(x => x.wellnessWorkOrder);

      this.rms = this.workOrderHelper.getUnique(this.allWorkOrders.map(wo => wo.representative));
      this.equipmentTypes = this.getUniqueNames(this.allWorkOrders.map(wo => { return this.workOrderHelper.getUniqueEquipment(wo).map(e => e.type) }).reduce((acc, curr) => acc.concat(curr), [])
                                       .concat((this.allWorkOrders.map(wo => { return this.workOrderHelper.getUniqueGoBackEquipment(wo).map(e => e.type) }).reduce((acc, curr) => acc.concat(curr), []))));

      this.filteredWorkOrders = this.allWorkOrders;
      this.isLoading = false;
    });
  }

  updateBigDayBuckets() {
    const wellnessWorkOrderIds = this.filteredWorkOrders.map(x => x.id);

    this.filteredBigDayBuckets = this.allBigDayBuckets.filter(bdb => {
      return wellnessWorkOrderIds.includes(bdb.wellnessWorkOrderId);
    });
  }

  OnWoFilteringFinished(filteredWorkOrders: (FilteredWellnessWorkOrder | FilteredWorkWorkOrder | FilteredQuoteWorkOrder)[]) {
    this.filteredWorkOrders = filteredWorkOrders as FilteredWellnessWorkOrder[];
    this.updateBigDayBuckets();
  }
  
  private getUniqueNames(arr: any[]) {
    const unique = arr.map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter(e => arr[e]).map(e => arr[e]).sort();

    return unique.map(u => ({fullName: u}));
  }
}
